export default "__VITE_ASSET__WWl6so_2__"